import { 
  GET_USER_STATUS,
  GET_USER_STATUS_SUCCESS,
  GET_USER_STATUS_ERROR,

  GET_USER_STATUS_LIST,
  GET_USER_STATUS_LIST_SUCCESS,
  GET_USER_STATUS_LIST_ERROR,
  
  CREATE_USER_STATUS,
  CREATE_USER_STATUS_SUCCESS,
  CREATE_USER_STATUS_ERROR, 

  UPDATE_USER_STATUS,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_ERROR,

  DELETE_USER_STATUS,
  DELETE_USER_STATUS_SUCCESS,
  DELETE_USER_STATUS_ERROR,
} from "./actionTypes"
  
  const initialState = {
    GET_USER_STATUS_SUCCESS: "",
    GET_USER_STATUS_ERROR: "",
    GET_USER_STATUS_LIST_SUCCESS: "",
    GET_USER_STATUS_LIST_ERROR: "",
    CREATE_USER_STATUS_SUCCESS: "",
    CREATE_USER_STATUS_ERROR: "",
    UPDATE_USER_STATUS: "",
    UPDATE_USER_STATUS_SUCCESS: "",
    UPDATE_USER_STATUS_ERROR: "",
    DELETE_USER_STATUS: "",
    DELETE_USER_STATUS_SUCCESS: "",
    DELETE_USER_STATUS_ERROR: "",
    loading: false,
  }
  
  const reducer = (state = initialState, action: any) => {
    switch (action.type) {
      // ---------------------------------------------GET_USER_STATUS
      case GET_USER_STATUS:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_USER_STATUS_SUCCESS:
        state = {
          ...state,
          GET_USER_STATUS_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_USER_STATUS_ERROR:
        state = { 
          ...state, 
          GET_USER_STATUS_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------GET_USER_STATUS_LIST
      case GET_USER_STATUS_LIST:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_USER_STATUS_LIST_SUCCESS:
        state = {
          ...state,
          GET_USER_STATUS_LIST_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_USER_STATUS_LIST_ERROR:
        state = { 
          ...state, 
          GET_USER_STATUS_LIST_ERROR: action.payload, 
          loading: false 
        }
        break
        
      // ---------------------------------------------CREATE_USER_STATUS
      case CREATE_USER_STATUS:
        state = {
          ...state,
          loading: true,
        }
        break

      case CREATE_USER_STATUS_SUCCESS:
        state = {
          ...state,
          CREATE_USER_STATUS_SUCCESS: action.payload,
          loading: false,
        }
        break

      case CREATE_USER_STATUS_ERROR:
        state = { 
          ...state, 
          CREATE_USER_STATUS_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------UPDATE_USER_STATUS
      case UPDATE_USER_STATUS:
        state = {
          ...state,
          loading: true,
        }
        break

      case UPDATE_USER_STATUS_SUCCESS:
        state = {
          ...state,
          UPDATE_USER_STATUS_SUCCESS: action.payload,
          loading: false,
        }
        break

      case UPDATE_USER_STATUS_ERROR:
        state = { 
          ...state, 
          UPDATE_USER_STATUS_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DELETE_USER_STATUS
      case DELETE_USER_STATUS:
        state = {
          ...state,
          loading: true,
        }
        break

      case DELETE_USER_STATUS_SUCCESS:
        state = {
          ...state,
          DELETE_USER_STATUS_SUCCESS: action.payload,
          loading: false,
        }
        break

      case DELETE_USER_STATUS_ERROR:
        state = { 
          ...state, 
          DELETE_USER_STATUS_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DEFAULT
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default reducer
  